import { render, staticRenderFns } from "./ProjectMultiselectOptionV2.vue?vue&type=template&id=2c110054"
import script from "./ProjectMultiselectOptionV2.vue?vue&type=script&lang=ts"
export * from "./ProjectMultiselectOptionV2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c110054')) {
      api.createRecord('2c110054', component.options)
    } else {
      api.reload('2c110054', component.options)
    }
    module.hot.accept("./ProjectMultiselectOptionV2.vue?vue&type=template&id=2c110054", function () {
      api.rerender('2c110054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/ProjectMultiselectOptionV2.vue"
export default component.exports